exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-60202333]{margin-top:2rem}input[data-v-60202333],textarea[data-v-60202333]{margin-bottom:1rem}input[type=submit][data-v-60202333]{transition:all .3s ease}input[type=submit][data-v-60202333]:disabled{background:#ccc}.social a[data-v-60202333]{color:#333;text-decoration:none;display:flex;align-items:center}.social img[data-v-60202333]{width:16px;height:16px;opacity:.6;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60202333","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Contact.vue
// module id = 90
// module chunks = 0